import * as React from 'react';

import TopPartners from 'bundles/search-common/components/TopPartners';
import { useMediumIntentContext } from 'bundles/search-common/providers/MediumIntentProvider';
import { getMediumIntentPartnerData } from 'bundles/search-common/utils/pageConfigUtils';

const TopCourseraPartnersRenderer = () => {
  const { mediumIntentData, loading: mediumIntentLoading } = useMediumIntentContext();
  const partnerData = getMediumIntentPartnerData()
    .filter((partner) => partner.relationSlug !== mediumIntentData?.matchedEntity)
    .slice(0, 8);
  if (mediumIntentLoading) {
    return null;
  }

  return <TopPartners partners={partnerData} />;
};

export default TopCourseraPartnersRenderer;
